export default __webpack_public_path__ + "static/media/nigeria’s-buhari-restores-oil-permits.5f046a16.jpg";